/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
//require('./formatters');
//import {formatters} from './formatters';
//require('jquery');
//import $ from "jquery";
//var $ = require("jquery");

require('./ga-events');
require('./formatters');
require('./validators');

require('./bootstrap');
import 'bootstrap';

window.autosize = require('autosize');
const axios = require('axios');

require('./vue-app');

import "select2/dist/js/select2";
// animation
import AOS from "aos";
//jquery
window.$ = window.jQuery = require("jquery");

// file input
import bsCustomFileInput from "bs-custom-file-input";

// owl carousel
let owl_carousel = require("owl.carousel");
window.fn = owl_carousel;

// waypoints js
import "waypoints/lib/noframework.waypoints.min.js";
import "waypoints/lib/shortcuts/inview.min.js";

/**
 *
 * script for site
 *
 */
window.onscroll = function () {
    stickyTopNav()
};

var header = document.getElementById("top-nav");
var sticky = header.offsetTop;

function stickyTopNav() {
    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}

$(document).ready(function () {
    //
    bsCustomFileInput.init();

    // background video speed
    var video = document.getElementById("bg_video");
    if (video) {
        video.playbackRate = 0.5;
    }

    //
    AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
    });


    // waypoint inview intersect for "Get Offer Here" button
    $('[data-waypoint="intersect"]').each(function (index, id) {
        var inview = new Waypoint.Inview({
            element: $(this)[0],
            enter: function (direction) {
                $(".get-offer-btn").removeClass('show');
            },

            exited: function (direction) {
                $(".get-offer-btn").addClass('show');
            }
        });
    });
    $(".get-offer-btn").click(function(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    });

    //
    // init select2
    if ($("#plateState").length > 0) {
        $('#plateState').select2({
            theme: 'bootstrap4',
            placeholder: 'Select plate state',
            minimumResultsForSearch: Infinity
        });
    }

    if ($("#position").length > 0) {
        $('#position').select2({
            theme: 'bootstrap4',
            placeholder: 'Select position',
            minimumResultsForSearch: Infinity
        });
    }


    // menu dropdown
    $('.navbar-collapse .nav-item.dropdown').hover(function () {
        $(this).find('.dropdown-menu').stop(true, true).fadeIn(500);
    }, function () {
        $(this).find('.dropdown-menu').stop(true, true).fadeOut(500);
    });



    // slider
    if ($(".client_slider").length > 0) {
        $('.client_slider').owlCarousel({
            items: 4,
            loop: true,
            nav: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 50,
                    center: true,
                    autoWidth: true,
                    margin: 18,
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        });
    }

    if ($(".fb-feed-slider").length > 0) {
        $('.fb-feed-slider').owlCarousel({
            items: 2,
            loop: true,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            margin: 18,
            responsive: {
                0: {
                    items: 1,
                    center: true,
                },
                768: {
                    items: 2
                },
            }
        });
    }

    if ($(".trademarks-slider").length > 0) {
        $('.trademarks-slider').owlCarousel({
            items: 1,
            center: true,
            loop: true,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
        });
    }


    let exteriorColorSelect = document.getElementById('exterior_color');

    if (exteriorColorSelect !== null) {
        document.getElementById('exterior_color').addEventListener('change', (event) => {
            let colorContainer = document.getElementById('color_other_container');

            if (event.target.value === 'other') {
                colorContainer.removeAttribute('hidden');
                return;
            }

            colorContainer.setAttribute('hidden', 'hidden');
        });
    }
});



// WEBPACK FOOTER //
// ./resources/js/gmtv.js